// src/modules/assetManagement/management/UploadQueueContext.tsx
// Shares one upload queue across Asset Management pages so uploads keep running while viewing an asset.
import React, { createContext, useContext } from "react";
import { Outlet } from "react-router-dom";
import { useUploadQueue } from "./useUploadQueue";

type Queue = ReturnType<typeof useUploadQueue>;

const UploadQueueContext = createContext<Queue | null>(null);

/** Layout route element for /asset-management/* */
export const UploadQueueLayout: React.FC = () => {
  const queue = useUploadQueue();
  return (
    <UploadQueueContext.Provider value={queue}>
      <Outlet />
    </UploadQueueContext.Provider>
  );
};

export const useSharedUploadQueue = (): Queue => {
  const queue = useContext(UploadQueueContext);
  if (!queue) throw new Error("useSharedUploadQueue must be used inside UploadQueueLayout");
  return queue;
};
